
<app-table-standard-layout [dataSource$]="combObs$" [title]="'Company Users'"  [rowActionButtons]="rowActionButtons" [topbarActionButton]="topbarActionButton" [columnSettings]="columnSettings" ></app-table-standard-layout>
